import { useEffect } from 'react';
import usePrevious from '../../effects/usePrevious';

const getDescriptionTemplate = eventType => {
  switch (eventType) {
    case 'client_release': {
      return `событие (открыта/включена, включен апдейт, подана, отменена/отключена, переподана)\n% пользователей (если событие распространяется на долю пользователей)\nдополнительная информация`;
    }
    case 'server_release': {
      return `основные изменения\nномера задач\nссылка на код в gitlab\nдополнительная информация`;
    }
    case 'config_deploy': {
      return `какие конфиги залиты (акция, сплит, фича, подарок и т.д.)\nосновные изменения\nдополнительная информация`;
    }
    case 'event_split': {
      return `событие (старт/финиш/миграция)\nспособ сплитования (миграции, сплиты, рнд, lifecycle, RoC.... - с подробностями, номерами сплитов, диапазонами рнд и т д)\nаудитория - старички/новички/lifecicle name...\nраспределение - пропорции (20/80, 50/50....)\nдополнительная информация`;
    }
    case 'game': {
      return `Краткое описание:\nНазвание слота/фичи/акции...:\nЗависание:\nНаличие креша:\nРаботоспособность платежей:\nКоличество обращений:\nUser case:\nUser ID:`;
    }
    case 's_partners_data': {
      return `Start loading costs or autobidding data by partner\nStop loading costs or autobidding data by partner\nUpdate loading costs or autobidding logic by partner\nReload historical costs or autobidding data from period`;
    }
    case 's_store': {
      return `Start loading data by store\nStop loading data by store\nUpdate loading logic by store\nReload historical data from period`;
    }
    case 's_extern_monetization': {
      return `Start loading data by partner\nStop loading data by partner\nUpdate loading logic by partner\nReload historical data from period`;
    }
    case 's_tracking_systems': {
      return `Integration SDK version\nDelete SDK\nUpdate SDK\nStart partner(s):\nStop partners(s):\nAdd new param(s):\nUpdate view logic`;
    }
    case 's_other_sdk': {
      return `Load historical data\nReload historical data from period\nIntegration SDK version\nDelete SDK\nUpdate SDK`;
    }
    case 's_server_events': {
      return `Add new field(s):\nDelete field(s):\nChange source for a field\nUpdate the module\nUpdate the logic\nAdd new event(s):`;
    }
    case 's_client_events': {
      return `Add new event(s):\nUpdate event(s):\nDelete event(s):\nAdd new user_state/params\nDelete user_state/params\nUpdate the logic`;
    }
    case 's_db_project': {
      return `Add new field(s): in table\nDelete field(s): from table\nUpdate the logic\nAdd a new table\nDelete a table`;
    }
    case 'w_in_out_come': {
      return `Update the dataset\nUpdate the logic\nReload historical data from period`;
    }
    case 'w_accounts_db': {
      return `Add a new table\nDelete a table\nAdd a new source for a table\nChange source for a table\nAdd new field(s): in table\nDelete field(s): from table\nChange field(s): in table\nAdd a new game/platform`;
    }
    case 'w_sls': {
      return `Update the logic\nAdd new field(s):\nDelete field(s):\nChange field(s):\nExclude event(s) from calculation\nAdd new game/platform`;
    }
    case 'w_gu_and_bi_ids': {
      return `Update the logic`;
    }
    case 'w_login_events': {
      return `Update the logic\nAdd new field(s):\nDelete field(s):\nReload historical data from period`;
    }
    case 'w_login_attribution': {
      return `Update the logic\nAdd new field(s): in table\nDelete field(s): from table\nReload historical data from period`;
    }
    case 'w_costs': {
      return `Update the logic\nAdd new field(s):\nDelete field(s):`;
    }
    case 'w_revenue': {
      return `Update the logic\nAdd new field(s):\nDelete field(s):`;
    }
    case 'w_ltv_forecast': {
      return `Update the logic\nAdd new field(s):\nDelete field(s):`;
    }
    case 'w_login_model': {
      return `Add a new table\nDelete a table\nAdd new field(s):\nDelete field(s):\nRename a table to\nRename a field to\nAdd a new game/platform`;
    }
    case 'w_lists': {
      return `Update the logic`;
    }
    case 'w_user_insights': {
      return `Add a new module\nUpdate a module\nUpdate the logic`;
    }
    case 'w_product_model': {
      return `Update the logic\nAdd a new table\nDelete a table\nAdd new field(s):\nDelete field(s):\nRename a table to\nRename a field to\nAdd a new game/platform`;
    }
    case 'r_books': {
      return `Add a new book\nDelete/stop a book\nAdd new sheet to book\nDelete a sheet from book\nAdd new metric(s) to book\nDelete metric(s) from Book\nAdd new dimension(s) to Book\nDelete dimension(s) from report\nUpdate a Book schedule to\nUpdate the logic of metrics\nUpdate source`;
    }
    case 'r_reports': {
      return `Add a new report\nDelete/stop a report\nAdd new sheet to report\nDelete sheet from report\nAdd new metric(s) to report\nDelete metric(s) from report\nAdd new dimension(s) to report\nDelete dimension(s) from report\nUpdate report schedule to\nUpdate the logic of metrics\nUpdate source`;
    }
    case 'tech_improves': {
      return ``;
    }
    default: {
      return null;
    }
  }
};

const clearDetailFields = setValue => {
  setValue('game');
  setValue('platform');
  setValue('dateTime');
  setValue('appVersion');
  setValue('minAppVersion');
  setValue('maxAppVersion');
  setValue('notesLink');
  setValue('description');
  setValue('responsible');
  setValue('serverVersion');
  setValue('audience');
  setValue('channel');
  setValue('resolutionDate');
  setValue('techTag');
  setValue('classTag');
  setValue('typeTag');
  setValue('engineVersion');
};

const clearEventType = setValue => {
  setValue('eventType');
};

const useFieldsController = (
  { eventType, direction, game },
  setValue,
  { directions },
) => {
  const prevEventType = usePrevious(eventType);
  const prevDirection = usePrevious(direction);

  useEffect(() => {
    if (directions.length === 1) {
      const direction = directions[0];
      setValue('direction', direction && direction.value);
    }
  }, [directions]);

  useEffect(() => {
    if (prevDirection) {
      clearEventType(setValue);
    }
  }, [direction]);

  useEffect(() => {
    setValue('platform');
  }, [game]);

  useEffect(() => {
    if (prevEventType) {
      clearDetailFields(setValue);
    }
    if (eventType) {
      const template = getDescriptionTemplate(eventType);
      setValue('description', template);
    }
  }, [eventType]);
};

export default useFieldsController;
